"use strict";
angular.module('app.modals.errorDot', [])

    .controller('errorDotCtrl', ['$scope', '$state', '_err', 'close', 'bundleId', 'ticketId', 'description', 'f_Interval',
        function ($scope, $state, _err, close, bundleId, ticketId, description, f_Interval) {

            var intervalId = f_Interval.registerInterval({
                'AppId': 'interval.errorDot.visualization',
                delay: 10000,
                fn: function () {
                    close();
                }
            });

            $scope.showErrors = function () {
                $scope.errorsShown = true;
                f_Interval.unregisterIntervalByAppId(intervalId);
            };

            if (bundleId) {
                $scope.bundle = _err.getBundle(bundleId);
            }
            $scope.ticketId = ticketId;
            $scope.description = description;


            $scope.dismissModal = function(){
                close();
            };
            $scope.close = function(){
                close();
            };
        }
    ])
    .factory('errorDotModal', ['ModalService', '$q', function (ModalService, $q) {
        return function (bundleId, ticketId, description) {
            return ModalService.showModal({
                controller: 'errorDotCtrl',
                templateUrl: "views/modals/errorDot.html",
                inputs: {
                    bundleId: bundleId,
                    ticketId: ticketId,
                    description: description
                }
            });
        }
    }]);